import moment from 'moment/moment'

/**
 * editor: moment+luxon format
 * viewer: luxon format
 * luxon은 datetime picker에서 따르기 때문에 사용하고
 * moment는 날짜계산하기 편해서 사용하고 있음
 * 포맷이 비슷한 형태이나 굳이 나눈 이유는 표현식이 차이가 있기 때문임
 */
const formatCode = [
  { moment: 'MMMM DD[, ]YYYY', picker: 'MMMM dd, yyyy' },
  { moment: 'YYYY[-]MM[-]DD', picker: 'yyyy-MM-dd' },
  { moment: 'DD[-]MM[-]YYYY', picker: 'dd-MM-yyyy' },
  { moment: 'YYYY[/]MM[/]DD', picker: 'yyyy/MM/dd' },
  { moment: 'DD[/]MM[/]YYYY', picker: 'dd/MM/yyyy' }
]
const DATE = {
  default: 0,
  dateFormat: formatCode,
  list: [],
  toString: function (date) {
    return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '-'
  }
}

for (let i = 0; i < formatCode.length; i++) {
  DATE.list.push({
    id: i,
    format: moment().format(formatCode[i].moment)
  })
}

export default DATE
